/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$footer-bar-background-color: #ffffff !default;
$footer-bar-link-color: #39393a !default;
$footer-bar-link-hover-color: #404040 !default;
$footer-bar-copyright-color: #8f9192 !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  @include eon-typography();
}

::slotted(eon-ui-link) {
  --contentColor: #{$footer-bar-link-color};
  --contentHoverColor: #{$footer-bar-link-hover-color};
}

::slotted([slot="logo"]) {
  --width: 106px;
  --height: auto;
}

footer {
  background-color: $footer-bar-background-color;
}

.#{$prefix}copyright {
  @include eon-typography();
  font-size: $copy-small-font-size;
  font-weight: $font-weight-regular;
  color: $footer-bar-copyright-color;

  @include for-size(tablet-or-larger) {
    white-space: nowrap;
  }
}

.#{$prefix}socialmedia {
  display: flex;
}

@include for-size(desktop-or-larger) {
  ::slotted([slot="socialmedia"]) {
    margin: 0 16px !important;
  }

  ::slotted([slot="links"]) {
    margin: 0 12px !important;
  }

  .#{$prefix}footer-content-wrapper {
    max-width: 1200px;
    margin: 0 auto 0 auto;
    width: 100%;
  }
  .#{$prefix}footer-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 21px 0px 24px 0px;

    .#{$prefix}link-content {
      display: flex;
      flex-direction: row;
      flex: 1;
    }

    .#{$prefix}logo-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }

    .#{$prefix}socialmedia {
      width: 47%;
    }

    .#{$prefix}links {
      width: auto;
    }

    .#{$prefix}copyright-content {
      display: flex;
      justify-content: flex-end;
      align-self: center;
    }

    .#{$prefix}logo {
      display: flex;
      justify-content: flex-end;
      width: auto;
      margin-left: 80px;
      align-self: center;
    }
  }
}

@include for-size(desktop) {
  ::slotted([slot="socialmedia"]) {
    margin: 0 12px !important;
  }

  ::slotted([slot="links"]) {
    margin: 0 12px !important;
  }

  .#{$prefix}footer-wrapper {
    padding: 21px 10px 24px 10px;

    .#{$prefix}socialmedia {
      width: 45%;
    }

    .#{$prefix}logo {
      margin-left: 50px;
      align-self: center;
    }
  }
}

@include for-size(tablet) {
  ::slotted([slot="socialmedia"]) {
    margin: 0 12px !important;
  }

  ::slotted([slot="links"]) {
    margin: 0 12px !important;
  }

  .#{$prefix}footer-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 21px 32px 25px 24px;

    .#{$prefix}link-content {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 35px;
    }

    .#{$prefix}logo-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 0 12px;
    }

    .#{$prefix}socialmedia {
      width: 40%;
    }

    .#{$prefix}links {
      width: 60%;
      display: flex;
      justify-content: flex-end;
    }

    .#{$prefix}copyright-content {
      display: flex;
      justify-content: flex-end;
      align-self: center;
      order: 2;
    }

    .#{$prefix}logo {
      width: auto;
      display: flex;
      justify-content: flex-end;
      margin-right: 24px;
      align-self: center;
      order: 1;
    }
  }
}

@include for-size(phone) {
  ::slotted([slot="socialmedia"]) {
    margin: 0 12px !important;
  }

  ::slotted([slot="links"]) {
    margin: 0 12px;
  }

  .#{$prefix}footer-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 32px 24px 25px 24px;

    .#{$prefix}link-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 35px;
    }

    .#{$prefix}logo-content {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 0 12px;
    }

    .#{$prefix}socialmedia {
      width: 100%;
      margin-bottom: 30px;
    }

    .#{$prefix}links {
      width: 100%;
      display: flex;
      flex-direction: column;
    }

    .#{$prefix}copyright-content {
      display: flex;
      justify-content: flex-start;
      align-self: center;
      width: 100%;
      order: 2;
    }

    .#{$prefix}logo {
      display: flex;
      justify-content: flex-start;
      align-self: center;
      width: 100%;
      order: 1;
      margin-bottom: 24px;
    }
  }
}
